import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';

export const trackTrainingClicked = () => {
  gspx.trackEvent({
    name: 'open_training_page',
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.NAVIGATION,
    capability: GPX_CAPABILITIES.NAVIGATION,
    route: GPX_ROUTES.NAVBAR,
  });
};
